'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.required = required;
exports.email = email;
exports.pin = pin;
exports.phone = phone;
exports.isTrue = isTrue;
exports.maxLength = maxLength;
exports.integer = integer;
exports.zip = zip;
exports.createValidator = createValidator;

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var join = function join(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0 /* first error */];
  };
};

function required(value) {
  if (_validator2.default.isEmpty(value)) {
    return {
      rule: 'required'
    };
  }
}

function email(value) {
  if (!_validator2.default.isEmail(value)) {
    return {
      rule: 'email'
    };
  }
}

function pin(value) {
  if (!_validator2.default.isEmpty(value) && !/^[0-9]{4}$/i.test(value)) {
    return {
      rule: 'pin'
    };
  }
}

/*
export function pin(value) {
  if (!validator.isEmpty(value) && !/^[0-9]{6}\/?[0-9]{4}$/i.test(value)) {
    return {
      rule: 'pin',
    };
  }
}*/

function phone(value) {
  if (!_validator2.default.isMobilePhone(value, 'cs-CZ')) {
    return {
      rule: 'phone'
    };
  }
}

function isTrue(value) {
  if (value !== true) {
    return {
      rule: 'isTrue'
    };
  }
}

function maxLength(max) {
  return function (value) {
    if (!_validator2.default.isLength(value, { max: max })) {
      return {
        rule: 'maxLength',
        max: max
      };
    }
  };
}

function integer(value) {
  if (!_validator2.default.isInt(value)) {
    return {
      rule: 'integer'
    };
  }
}

function zip(value) {
  if (!_validator2.default.isEmpty(value) && !/^[0-9]{3}\ ?[0-9]{2}$/i.test(value)) {
    return {
      rule: 'zip'
    };
  }
}

function createValidator(rules) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var errors = {};
    (0, _keys2.default)(rules).forEach(function (key) {
      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      var error = rule(typeof data[key] === 'undefined' ? '' : data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/validation.js
// module id = 566
// module chunks = 0